import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Admin Layout and Pages
import Admin from "../Pages/Admin/Admin";
import Dashboard from "../Pages/Admin/Pages/Dashboard/Dashboard";
import BibleLanguageList from "../Pages/Admin/Pages/Bible/BibleLanguageList";
import BibleBookList from "../Pages/Admin/Pages/Bible/BibleBookList";
import BookManager from "../Pages/Admin/Pages/Books/BookManager/BookManager";
import VideoManager from "../Pages/Admin/Pages/Videos/VideoManager/VideoManager";
import SeriesManager from "../Pages/Admin/Pages/Series/SeriesManager";

// CMS and its nested pages
import CMS from "../Pages/Admin/Pages/CMS/CMS";
import CategoryManager from "../Pages/Admin/Pages/CMS/CategoryManager/CategoryManager";
import AboutUs from "../Pages/Admin/Pages/CMS/AboutUs/AboutUs";
import SignIn from "../Pages/Auth/SignIn";
import Home from "../Pages/Admin/Pages/CMS/Home/Home";
import ProtectedRoute from "../libs/ProtectedRoute ";
import Chat from "../Pages/Admin/Pages/Chat/Chat";
import AudioManager from "../Pages/Admin/Pages/CMS/WhisperMusic/AudioManager/AudioManager";
import LanguageMaster from "../Pages/Admin/Pages/CMS/LanguageMaster/LanguageMaster";
import SectionMaster from "../Pages/Admin/Pages/CMS/SectionMaster/SectionMaster";
import HomeSectionManager from "../Pages/Admin/Pages/CMS/SectionMaster/HomeSectionManager";
import NotificationSender from "../Pages/Admin/Pages/CMS/Notification/NotificationSender";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<SignIn />} />

        {/* Protected Admin Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        >
          {/* Admin Pages */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="bible" element={<BibleLanguageList />} />
          <Route path="bible/books/:languageId" element={<BibleBookList />} />
          <Route path="books" element={<BookManager />} />
          <Route path="videos" element={<VideoManager />} />
          <Route path="series" element={<SeriesManager />} />
          <Route path="chat" element={<Chat />} />

          {/* CMS Pages Nested under /admin/cms */}
          <Route path="cms" element={<CMS />}>
            <Route path="advertisement" element={<Home />} />
            <Route path="categories" element={<CategoryManager />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="audio" element={<AudioManager />} />
            <Route path="language-master" element={<LanguageMaster />} />
            <Route path="homeSection" element={<HomeSectionManager />} />
            <Route path="notifications" element={<NotificationSender />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
